import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import CssHelper from 'Services/Utils/Css/CssHelper';
import { Icon, ICONS } from '../Icon/Icon';
import Text from '../Text/Text';
import styles from './Tag.module.sass';
import Tooltip from 'Components/Atoms/Tooltip/Tooltip';

const Tag = ({children, tooltip, url, onDelete, transparent}: any) => {
    const cssClassname = CssHelper.createCssClass(`
        ${styles['tag']}
        ${transparent ? styles['tag--transparent'] : styles['tag--default']}
    `);

    const [tooltipRef, setTooltipRef] = useState<any>(null);
    const [showTooltip, setShowTooltip] = useState(false);

    const handleTooltipHover = (value: boolean) => () => setShowTooltip(value);

    return <div
        className={cssClassname}
        ref={setTooltipRef}
        onMouseEnter={handleTooltipHover(true)}
        onMouseLeave={handleTooltipHover(false)}
    >
        <Text>
            { url && <Link to={url} className={styles['link']}>
                { children }
            </Link> }
            { !url && children }
        </Text>
        {
            onDelete &&
            <div className={styles['tag__close']} onClick={() => onDelete()}>
                <Icon type={ICONS.CLOSE} size={'small'}/>
            </div>
        }
        {
            tooltip
            && showTooltip
            && <Tooltip ref={tooltipRef}>
                { tooltip }
            </Tooltip>
        }
    </div>;
}

export default React.memo(Tag);